import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref } from 'vue';
import { HeadingDisplay } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';

import { HomeBalanceSummaryLoader } from './components/HomeBalanceSummaryLoader';
import { SectionError } from '@/modules/common/components/SectionError';
import {
  BalancesResponse,
  TotalBalanceResponse
} from '@/modules/home/services/bff';
import { HomeHero } from '../HomeHero';

interface Props {
  balanceDetails?: TotalBalanceResponse | BalancesResponse;
  loading: boolean;
  hasError: boolean;
  isOverdue: boolean;
  shouldUseNewBalancesRoute: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeBalanceSummary',
  props: {
    balanceDetails: null,
    loading: { type: Boolean },
    hasError: { type: Boolean },
    isOverdue: { type: Boolean },
    shouldUseNewBalancesRoute: { type: Boolean }
  },
  emits: ["on-retry"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  balanceDetails?: TotalBalanceResponse | BalancesResponse;
  loading: boolean;
  hasError: boolean;
  isOverdue: boolean;
  shouldUseNewBalancesRoute: boolean;
};





const addLoadedClass = inject<boolean>('shouldTriggerHomeAnimations', false);

const retry = ref(false);
const hasHomeCashError = ref(false);

const onRetry = () => {
  retry.value = !retry.value;
  hasHomeCashError.value = false;
  emit('on-retry');
};

const total = computed(() => {
  if (!props.balanceDetails) return '';
  return props.shouldUseNewBalancesRoute
    ? (props.balanceDetails as TotalBalanceResponse).totalBalance.formatted
    : (props.balanceDetails as BalancesResponse).totalBalance.value;
});

const totalUpdatedAt = computed(() => {
  if (!props.balanceDetails) return '';
  return props.shouldUseNewBalancesRoute
    ? (props.balanceDetails as TotalBalanceResponse).updatedAt
    : (props.balanceDetails as BalancesResponse).balancesLastUpdatedAtFormatted;
});

const canLoadComponents = computed(() => {
  return !props.hasError && !props.loading;
});

const handleHomeCashError = (isError: boolean) => {
  hasHomeCashError.value = isError;
};

return { __sfc: true,props, emit, addLoadedClass, retry, hasHomeCashError, onRetry, total, totalUpdatedAt, canLoadComponents, handleHomeCashError, HeadingDisplay, Money, HomeBalanceSummaryLoader, SectionError, HomeHero }
}

})